import { ADMIN_ROLES } from "./adminPanelMenu";

// Todas as telas do admin têm versão nova em AdminPanel/pages. O admin clássico (AdminBackoffice)
// continua usando as telas originais. Os detalhes do pedido ainda usam o componente compartilhado
// com o dashboard de usuários.
import OrderDetails from "../../UserDashboard/components/OrderDetails/OrderDetails";

import AdminHome from "../pages/AdminHome/AdminHome";
import AdminUsers from "../pages/AdminUsers/AdminUsers";
import AdminBankTransfers from "../pages/AdminBankTransfers/AdminBankTransfers";
import AdminWithdrawRequests from "../pages/AdminWithdrawRequests/AdminWithdrawRequests";
import AdminExcWithdrawRequests from "../pages/AdminExcWithdrawRequests/AdminExcWithdrawRequests";
import AdminOrders from "../pages/AdminOrders/AdminOrders";
import AdminPendingOrders from "../pages/AdminPendingOrders/AdminPendingOrders";
import AdminProducts from "../pages/AdminCatalog/AdminProducts";
import AdminCategories from "../pages/AdminCatalog/AdminCategories";
import AdminSubcategories from "../pages/AdminCatalog/AdminSubcategories";
import AdminBrands from "../pages/AdminCatalog/AdminBrands";
import AdminTypes from "../pages/AdminCatalog/AdminTypes";
import AdminPaidOrdersReport from "../pages/AdminReports/AdminPaidOrdersReport";
import AdminPaidSubscriptionsReport from "../pages/AdminReports/AdminPaidSubscriptionsReport";
import AdminCompletedWithdrawalsReport from "../pages/AdminReports/AdminCompletedWithdrawalsReport";
import AdminPhysicalStores from "../pages/AdminPhysicalStores/AdminPhysicalStores";
import AdminBangood from "../pages/AdminBangood/AdminBangood";
import AdminPaidSubscriptions from "../pages/AdminPaidSubscriptions/AdminPaidSubscriptions";
import AdminIntegrations from "../pages/AdminIntegrations/AdminIntegrations";
import AdminSendcloudAddress from "../pages/AdminSendcloudAddress/AdminSendcloudAddress";
import AdminBanners from "../pages/AdminBanners/AdminBanners";
import AdminWhitelabel from "../pages/AdminWhitelabel/AdminWhitelabel";

const accountantRoutes = [
  { path: "/dashboard-report-paidorders", render: () => <AdminPaidOrdersReport /> },
  { path: "/admin/report/paidorders", exact: true, render: () => <AdminPaidOrdersReport /> },
  {
    path: "/dashboard-report-completedwithdrawals",
    render: () => <AdminCompletedWithdrawalsReport />,
  },
  {
    path: "/admin/report/completedwithdrawals",
    exact: true,
    render: () => <AdminCompletedWithdrawalsReport />,
  },
  {
    path: "/dashboard-report-paidsubscriptions",
    render: () => <AdminPaidSubscriptionsReport />,
  },
];

const adminRoutes = [
  { path: "/dashboard", exact: true, render: () => <AdminHome /> },
  // `key` recria a tela ao trocar de lista, zerando busca e filtros
  { path: "/dashboard-listareamanagers", render: () => <AdminUsers key="am" plan="areamanager" /> },
  {
    path: "/dashboard-listbusinesspartners",
    render: () => <AdminUsers key="bp" plan="businesspartner" />,
  },
  {
    path: "/dashboard-listspecialcustomers",
    render: () => <AdminUsers key="sc" plan="specialcustomer" />,
  },
  { path: "/dashboard-listsalepromoters", render: () => <AdminUsers key="sp" plan="salepromoter" /> },
  { path: "/dashboard-listsellers", render: () => <AdminUsers key="se" plan="sellers" /> },
  { path: "/dashboard-listproducts", render: () => <AdminProducts /> },
  { path: "/dashboard-banktransfers", render: () => <AdminBankTransfers /> },
  { path: "/dashboard-listwithdrawrequests", render: () => <AdminWithdrawRequests /> },
  { path: "/dashboard-listexcwithdrawrequests", render: () => <AdminExcWithdrawRequests /> },
  { path: "/dashboard-listcategory", render: () => <AdminCategories /> },
  { path: "/dashboard-newcategories", render: () => <AdminCategories startCreating /> },
  { path: "/dashboard-listbrands", render: () => <AdminBrands /> },
  { path: "/dashboard-newbrands", render: () => <AdminBrands startCreating /> },
  { path: "/dashboard-listtypes", render: () => <AdminTypes /> },
  { path: "/dashboard-newtypes", render: () => <AdminTypes startCreating /> },
  { path: "/dashboard-listsubcategories", render: () => <AdminSubcategories /> },
  { path: "/dashboard-newsubcategory", render: () => <AdminSubcategories startCreating /> },
  { path: "/dashboard-address", render: () => <AdminSendcloudAddress /> },
  { path: "/dashboard-paidsubscriptions", render: () => <AdminPaidSubscriptions /> },
  { path: "/dashboard-listorders", render: () => <AdminOrders /> },
  {
    path: "/dashboard-pendings",
    render: ({ userInfo }) => <AdminPendingOrders userInfo={userInfo?.user} />,
  },
  {
    path: "/dashboard-purchasesdetails/",
    render: ({ userInfo }) => (
      <OrderDetails admin={true} sales={true} userInfo={userInfo?.user} plan={userInfo?.plan} />
    ),
  },
  { path: "/dashboard-bangood", render: () => <AdminBangood /> },
  { path: "/dashboard-metaads", render: () => <AdminIntegrations /> },
  { path: "/dashboard-gtm", render: () => <AdminIntegrations /> },
  { path: "/dashboard-banners", render: () => <AdminBanners key="main" type="main" /> },
  {
    path: "/dashboard-subbanners1",
    render: () => <AdminBanners key="sub1" type="sub1" />,
  },
  {
    path: "/dashboard-subbanners2",
    render: () => <AdminBanners key="sub2" type="sub2" />,
  },
  {
    path: "/dashboard-subbanners3",
    render: () => <AdminBanners key="sub3" type="sub3" />,
  },
  { path: "/dashboard-whitelabel-users", render: () => <AdminWhitelabel /> },
  { path: "/dashboard-listphysicalstores", render: () => <AdminPhysicalStores /> },
  {
    path: "/dashboard-report-paidorders",
    render: () => <AdminPaidOrdersReport canManageInvoicing />,
  },
  { path: "/admin/report/paidorders", exact: true, render: () => <AdminPaidOrdersReport /> },
  {
    path: "/dashboard-report-completedwithdrawals",
    render: () => <AdminCompletedWithdrawalsReport />,
  },
  {
    path: "/admin/report/completedwithdrawals",
    exact: true,
    render: () => <AdminCompletedWithdrawalsReport />,
  },
  {
    path: "/dashboard-report-paidsubscriptions",
    render: () => <AdminPaidSubscriptionsReport canManageInvoicing />,
  },
];

export const getAdminPanelRoutes = (userType) =>
  userType === ADMIN_ROLES.ACCOUNTANT ? accountantRoutes : adminRoutes;

export const getAdminPanelFallbackPath = (userType) =>
  userType === ADMIN_ROLES.ACCOUNTANT ? "/dashboard-report-paidorders" : "/dashboard";
